const showEmployerFields = (professionGroup) => [
    "SKILLED_LABOUR",
    "WORKER",
    "MANAGER",
    "EMPLOYEE",
    "DEPENDENTLY_EMPLOYED_SOLICITOR",
    "DEPENDENTLY_EMPLOYED_GRADUATE_PROFESSION",
    "APPRENTICE",
    "DIPLOMAT",
    "GASTRONOMY_EMPLOYEE",
    "WORKER_AGRICULTURE",
    "TRUCK_DRIVER",
    "HEALTH_CARE",
    "OFFICER_PROFESSIONAL_SOLDIER",
    "PERSON_IN_COMMUNITY_SERVICE",
    "REGULAR_SOLDIER",
    "CIVIL_SERVANT_HIGHER_SERVICE",
    "CIVIL_SERVANT",
    "FARMER",
].includes(professionGroup);

const showContractType = (professionGroup) => [
    "SKILLED_LABOUR",
    "WORKER",
    "MANAGER",
    "EMPLOYEE",
    "DEPENDENTLY_EMPLOYED_SOLICITOR",
    "DEPENDENTLY_EMPLOYED_GRADUATE_PROFESSION",
    "APPRENTICE",
    "DIPLOMAT",
    "GASTRONOMY_EMPLOYEE",
    "WORKER_AGRICULTURE",
    "TRUCK_DRIVER",
    "HEALTH_CARE",
    "OFFICER_PROFESSIONAL_SOLDIER",
    "PERSON_IN_COMMUNITY_SERVICE",
    "REGULAR_SOLDIER",
    "CIVIL_SERVANT_HIGHER_SERVICE",
    "CIVIL_SERVANT",
    "FARMER"
].includes(professionGroup);

const showProfessionField = (professionGroup) => [
    "FARMER"
].includes(professionGroup);

const showEmployedSince = (professionGroup) => [
    "SKILLED_LABOUR",
    "WORKER",
    "MANAGER",
    "EMPLOYEE",
    "DEPENDENTLY_EMPLOYED_SOLICITOR",
    "DEPENDENTLY_EMPLOYED_GRADUATE_PROFESSION",
    "APPRENTICE",
    "DIPLOMAT",
    "GASTRONOMY_EMPLOYEE",
    "WORKER_AGRICULTURE",
    "TRUCK_DRIVER",
    "HEALTH_CARE",
    "OFFICER_PROFESSIONAL_SOLDIER",
    "PERSON_IN_COMMUNITY_SERVICE",
    "REGULAR_SOLDIER",
    "CIVIL_SERVANT_HIGHER_SERVICE",
    "CIVIL_SERVANT",
    "FARMER",
    "PENSIONER"
].includes(professionGroup);

const hideEmploymentPeriod = (professionGroup) => [
    "STUDENT",
    "PUPIL",
    "UNEMPLOYED",
    "SELFEMPLOYED",
    "HOMEMAKER",
    "PENSIONER",
    "PERSON_WITHOUT_VOCATIONAL_QUALIFICATION",
    "WELFARE_RECIPIENT",
    "APPRENTICE"
].includes(professionGroup);

const hideIndustryField = (professionGroup) => [
    "UNEMPLOYED",
    "HOMEMAKER",
    "PERSON_WITHOUT_VOCATIONAL_QUALIFICATION",
    "PENSIONER",
    "PUPIL",
    "SELFEMPLOYED",
    "STUDENT",
    "ASYLUM_SEEKER",
    "UNSKILLED_LABOUR",
].includes(professionGroup) || !professionGroup
  
export {
    showContractType,
    showProfessionField,
    showEmployerFields,
    showEmployedSince,
    hideEmploymentPeriod,
    hideIndustryField,
}